import Crest from "./Crest";
import { scrollToSection } from "../lib/scroll";

const LINKS = [
  { label: "The Passport", href: "#passport", testid: "nav-passport-link" },
  { label: "Nations", href: "#nations", testid: "nav-nations-link" },
  { label: "Parliament", href: "#parliament", testid: "nav-parliament-link" },
  { label: "Manifesto", href: "#manifesto", testid: "nav-manifesto-link" },
  { label: "Gazette", href: "#gazette", testid: "nav-gazette-link" },
];

export default function Navbar() {
  const go = (e, href) => {
    e.preventDefault();
    scrollToSection(href);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-[#00A651]/15 bg-[#0A0C0E]/75 backdrop-blur-xl" data-testid="main-navbar">
      <div className="absolute top-0 inset-x-0 h-1 flex" data-testid="panafrican-ribbon">
        <span className="flex-1 bg-[#009B4D]" />
        <span className="flex-1 bg-[#FFD700]" />
        <span className="flex-1 bg-[#CE1126]" />
      </div>
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto h-[72px] flex items-center justify-between gap-6">
        <a
          href="#top"
          onClick={(e) => go(e, "#top")}
          className="flex items-center gap-3 shrink-0"
          data-testid="nav-home-link"
        >
          <Crest className="w-9 h-9" />
          <span className="font-display font-extrabold tracking-tight text-sm sm:text-base leading-none">
            UNITED STATES
            <span className="block text-[#00A651]">OF AFRICA</span>
          </span>
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={l.testid}
              className="font-official text-[11px] tracking-[0.2em] uppercase text-[#8A99AD] hover:text-[#00A651] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <button
          onClick={(e) => go(e, "#join")}
          data-testid="nav-join-button"
          className="shrink-0 rounded-full bg-[#00A651] text-[#0A0C0E] font-display font-bold text-xs sm:text-sm px-5 py-2.5 tracking-wide hover:bg-[#2FC36A] hover:shadow-[0_0_24px_rgba(0,166,81,0.35)] transition-all duration-300"
        >
          Join The Movement
        </button>
      </div>
    </header>
  );
}
